import type { IUserIdParams } from "@commonTypes/user"
import type { IAccountExistsParams } from "./types"

export const accountKeys = {
  all: ["accounts"] as const,
  lists: () => [...accountKeys.all, "list"] as const,
  list: (filters: string) => [...accountKeys.lists(), { filters }] as const,
  details: () => [...accountKeys.all, "detail"] as const,
  detail: (account_id: string | undefined) =>
    [...accountKeys.details(), account_id] as const,
  agedAccounts: () => [...accountKeys.all, "agedAccounts"] as const,
  energyImpact: (account_id: string) =>
    [...accountKeys.all, "energyImpact", account_id] as const,
  linkedAccounts: (account_id: string) =>
    [...accountKeys.all, "linkedAccounts", account_id] as const,
  accountEvents: (
    prospect_guid: string | undefined,
    account_id: string | undefined,
  ) =>
    [
      ...accountKeys.detail(account_id),
      "accountEvents",
      prospect_guid,
    ] as const,
  accountNotifications: (
    prospect_guid: string | undefined,
    account_id: string,
  ) =>
    [
      ...accountKeys.detail(account_id),
      "accountNotifications",
      prospect_guid,
    ] as const,
  accountCorrespondences: (account_id: string) =>
    [
      ...accountKeys.detail(account_id),
      "accountCorrespondences",
      account_id,
    ] as const,
  accountCorrespondenceLetter: (
    account_id: string,
    account_correspondence_id: number,
  ) =>
    [
      ...accountKeys.accountCorrespondences(account_id),
      "accountCorrespondenceLetter",
      account_correspondence_id,
    ] as const,
  welcomeKit: (account_id: string) =>
    [...accountKeys.detail(account_id), "welcomeKit"] as const,
  accountNumberHistory: (account_id: string) =>
    [...accountKeys.detail(account_id), "accountNumberHistory"] as const,
  accountPromos: (account_id: string) =>
    [...accountKeys.detail(account_id), "accountPromos"] as const,
  ordersList: (account_id: string) =>
    [...accountKeys.detail(account_id), "ordersList"] as const,
  orderAuthorizations: (account_id: string) =>
    [...accountKeys.detail(account_id), "orderAuthorizations"] as const,
  accountTPVs: (account_id: string) =>
    [...accountKeys.detail(account_id), "accountTPVs"] as const,
  accountPayableBills: (account_id: string) =>
    [...accountKeys.detail(account_id), "accountPayableBills"] as const,
  contractHistories: (account_id: string) =>
    [...accountKeys.detail(account_id), "contractHistories"] as const,
  billImages: (account_id: string) =>
    [...accountKeys.detail(account_id), "billImages"] as const,
  serviceHistories: (account_id: string) =>
    [...accountKeys.detail(account_id), "serviceHistories"] as const,
  accountTransactions: (account_id: string) =>
    [...accountKeys.detail(account_id), "accountTransactions"] as const,
  possibleAccountTransactions: (account_id: string) =>
    [...accountKeys.detail(account_id), "possibleAccountTransactions"] as const,
  offerChangeDetails: (account_id: string) =>
    [...accountKeys.detail(account_id), "offerChangeDetails"] as const,
  accountRejects: (account_id: string) =>
    [...accountKeys.detail(account_id), "accountRejects"] as const,
  accountRejectInformation: (
    account_id: string,
    reject_id: string | undefined,
  ) =>
    [
      ...accountKeys.accountRejects(account_id),
      "accountRejectInformation",
      reject_id,
    ] as const,
  dropReasons: () => [...accountKeys.all, "dropReasons"] as const,
  accountExists: (account_exists: IAccountExistsParams | undefined) =>
    [...accountKeys.details(), "accountExists", account_exists] as const,
  accountRewards: (account_id: string) =>
    [...accountKeys.detail(account_id), "accountRewards"] as const,
  accountReferrals: (account_id: string) =>
    [...accountKeys.detail(account_id), "accountReferrals"] as const,
  winbackOffersForAccount: (account_id: string, params: IUserIdParams) =>
    [
      ...accountKeys.detail(account_id),
      "winbackOffersForAccount",
      params,
    ] as const,
  retentionOffersForAccount: (account_id: string, params: IUserIdParams) =>
    [
      ...accountKeys.detail(account_id),
      "retentionOffersForAccount",
      params,
    ] as const,
}
